export const WarningButtonStyle = {
  color: 'white',
  XbackgroundColor: '#f44336',
  backgroundColor: '#f2af18',
  marginLeft: '10px',
  borderRadius: '0%',
  whiteSpace: 'nowrap'
}

export const ErrorButtonStyle = {
  color: 'white',
  backgroundColor: '#f44336',
  marginLeft: '10px',
  borderRadius: '0%',
  whiteSpace: 'nowrap'
}

export const SuccessButtonStyle = {
  color: 'white', 
  backgroundColor: 'darkgray',
  marginLeft: '10px',
  borderRadius: '0%'
}

export const InactiveButtonStyle = {
  color: 'white', 
  backgroundColor: 'darkgray',
  marginLeft: '10px',
  borderRadius: '0%'
}